// 管理体系
<template>
  <div class="mapwrap" v-if="isRefresh">
    <!-- <div>
      <el-tabs class="pollutionSrcsTabs" v-model="tabType" @tab-click="handleRefresh()" stretch>
        <el-tab-pane label="岗位职责" name='岗位职责'></el-tab-pane>
      </el-tabs>
    </div> -->
    <div class="searchInput">
      <el-button class="btnRefresh" type="primary" size="mini" @click="showAddDialog = true">新增</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" icon="el-icon-refresh-right" @click="handleRefresh">刷新</el-button>
    </div>
    <div class="mainTable">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="4%">序号</th>
          <th class="cell thtitle" v-for="(th, thi) in tableName" :key="thi">{{tableName[thi]}}</th>
          <th class="cell thtitle" width="12%">操作</th>
        </tr>
        <tr v-for="(item, index) in tableDataNew" :key="index">
          <td class="cell tdcell">{{index+1}}</td>
          <td class="cell tdcell" v-for="(cell, celli) in rowItems" :key="celli">
            <el-input v-if="item.editFlag" v-model="item[rowItems[celli]]"></el-input>
            <span v-else>{{item[rowItems[celli]]}}</span>
          </td>
          <td class="cell tdcell">
            <!-- <el-button type="text" size="mini" @click="editRow(item)">编辑</el-button> -->
            <!-- <el-button type="text" size="mini" @click="saveRow(item)">保存</el-button> -->
            <el-button type="text" size="mini" @click="importYear(item)">录入年报信息</el-button>
            <el-button type="text" size="mini" @click="deleteRow(item)">删除</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="bottom-pagination">
      <el-pagination
        hide-on-single-page
        small
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pages"
        :current-page="pageNo"
        :total="totalNumber">
      </el-pagination>
    </div>
    <nut-dialog
      @close="showAddDialog = false"
      v-if="showAddDialog"
      :visible="showAddDialog"
      title="新增报表"
      :noFooter="true">
      <nut-textinput
        label="报表名称"
        v-model="reportInfoC.reportName">
      </nut-textinput>
      <nut-textinput
        label="报表时间"
        v-model="reportInfoC.reportTime">
      </nut-textinput>
      <div style="text-align: center;">
        <el-button @click="addRow()" size="medium" type="primary">确认</el-button>
      </div>
    </nut-dialog>
    <nut-dialog
      @close="showYearDialog = false"
      v-if="showYearDialog"
      :visible="showYearDialog"
      title="年度报告数据录入"
      :noFooter="true">
      <ehsAnnualReportDialog :reportId="reportId"></ehsAnnualReportDialog>
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../../api/index'
import ehsAnnualReportDialog from '../ehsPage-com/ehsAnnualReportDialog'
export default {
  data () {
    return {
      tabType: '岗位职责',
      // showTabs: false,
      importFlag: false,
      extaParam: {},
      tableName: ['报表名称', '报表时间', '提交时间'],
      rowItems: ['reportName', 'reportTime', 'submissionTime'],
      tableData: [{
        id: 0,
        reportName: '',
        reportTime: '',
        submissionTime: '',
        editFlag: false
      }],
      reportInfoC: {
        reportName: '',
        reportTime: ''
      },
      showAddDialog: false,
      showYearDialog: false,
      reportId: 0,
      apiNew: '',
      rowItemsNew: [],
      enquiryPusher: {},
      tableDataNew: [],
      apiAdd: '',
      savePusher: {},
      apiSave: '',
      rowItemsSave: [],
      apiDelete: '',
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      isRefresh: true
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData (pageNo = 1) {
      this.apiNew = api.hbImplementReportEnquiry
      this.rowItemsNew = this.rowItems
      this.enquiryPusher = {
        category: 3,
        pages: this.pages,
        pageNo: pageNo
      }
      this.tableDataNew = this.tableData
      // api
      this.apiNew(this.enquiryPusher).then(res => {
        console.log(res)
        this.totalNumber = res.data.totalNumber
        var tempArr = []
        res.data.list.forEach(item => {
          var arrPusher = {
            id: item.id
          }
          for (var i = 0; i < this.rowItemsNew.length; i++) {
            if (this.rowItemsNew[i] in item) {
              // console.log(rowItemsNew[i])
              arrPusher[this.rowItemsNew[i]] = item[this.rowItemsNew[i]]
            }
          }
          arrPusher.editFlag = false
          tempArr.push(arrPusher)
        })
        this.tableDataNew = tempArr
        console.log('this.tableDataNew', this.tableDataNew)
      })
    },
    handleRefresh () {
      this.tableDataNew = this.tableData
      console.log('refresh', this.tabType)
      this.isRefresh = false
      this.$nextTick(function () {
        this.isRefresh = true
        this.pageNo = 1
        this.getTableData()
      })
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTableData(this.pageNo)
    },
    addRow () {
      this.apiAdd = api.hbImplementReportAdd
      this.savePusher = {
        category: 3,
        reportName: this.reportInfoC.reportName,
        reportTime: this.reportInfoC.reportTime
      }
      console.log('4', this.savePusher)
      // api
      this.apiAdd(this.savePusher).then(res => {
        console.log(res)
        this.showAddDialog = false
        this.$nextTick(function () {
          this.isRefresh = true
          this.pageNo = 1
          this.getTableData()
        })
      })
    },
    editRow (row) {
      row.editFlag = true
    },
    saveRow (row) {
      this.apiSave = api.hbImplementReportUpdate
      this.rowItemsSave = this.rowItems
      // api
      this.apiSave({
        id: row.id,
        submissionTime: this.getTime()
      }).then(res => {
        console.log(res)
        row.editFlag = false
      })
    },
    deleteRow (row) {
      this.apiDelete = api.hbImplementReportDelete
      // api
      this.apiDelete({ id: row.id }).then(res => {
        console.log(res)
        this.getTableData()
      })
    },
    checkUpload () {
      this.$refs.uploadRef.doUpload()
    },
    handleSuccess () {
      this.$toast.text('上传成功')
      this.importFlag = false
      this.getTableData()
    },
    importYear (row) {
      this.showYearDialog = true
      this.reportId = row.id
    }
  },
  components: {
    ehsAnnualReportDialog
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.homepage{
  width: 100%;
  div{
    border-radius: 2px;
  }
}
.mapwrap{
  z-index: 0;
  height: 100%;
  overflow: hidden;
}
.pollutionSrcsTabs{
  margin: 0 10px;
}
.searchInput{
  width: 50%;
  margin: 4px 10px;
  // padding-left: 10px;
  display: flex;
  font-size: 16px;
  .searchInput-prepend{
    font-weight: bold;
  }
  // margin-top: 0;
  // .searchInput div{
  //   height: 40px;
  //   // line-height: 40px;
  // }
  // .searchLabel{
  //   padding-top: 1px;
  //   height: 32px;
  //   font-size: 17px;
  // }
  // .el-input__icon{
  //   width: 20px!important;
  //   line-height: 28px!important;
  // }
}
.btnRefresh{
  margin: 0 10px 0 0!important;
}
.btnUpdate{
  margin: 0 0 0 10px!important;
  width: 120px!important;
}
.mainTable{
  margin: 10px;
  width: calc(100% - 20px);
  .tableFileCell{
    text-decoration: underline;
    color: #00C;
  }
  .tableFileCell:hover{
    color: #66F;
    text-decoration: none;
  }
  .cell{
    border: 1px #ccc solid;
    text-align: center;
  }
  .thtitle{
    background-color: #fafafa;
    line-height: 24px;
  }
  .tdcell{
    background-color: #fff;
    line-height: 32px;
    padding: 2px;
    .el-input__inner{
      height: 28px!important;
    }
  }
}
.bottom-pagination .el-pagination {
  text-align: right;
  margin-top: 6px;
  margin-bottom: 6px;
}

.el-card{
  margin-top: 4px;
  .el-card__header{
    padding: 0;
  }
  .el-card__body{
    padding: 0;
    overflow-y: auto;
  }
}
</style>
